import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'My Position',
    withdraw: 'Withdraw',
    delegateMore: 'Delegate More',
  },
};
